import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/tutoriales')({
  beforeLoad: () => {
    // Redirect to external Notion URL
    if (typeof window !== 'undefined') {
      window.location.replace('https://colossal-condition-f6c.notion.site/JeridSchool-Videos-tutorial-2d39e75d867780d4be2bec6381b7d632')
    }
  },
  component: () => null,
})

